import { extractLinkDataFromUrl } from '#features/guest-links';
import { appRoutes, isInTwoFactorAuthenticationLoginFlow } from '#services';
export const guestLinkPrivateRoutePredicate = ({ currentUser, location, }) => {
    const { fullHash, pathname } = extractLinkDataFromUrl(location);
    const navigatedFrom = pathname + fullHash;
    const [_, _guestpath, guestLinkId] = pathname.split('/');
    if (!fullHash || isInTwoFactorAuthenticationLoginFlow(currentUser)) {
        return {
            isSuccess: false,
            navigateTo: appRoutes.login(),
        };
    }
    if (!currentUser) {
        const { shouldGoToLogin } = location?.state ?? {};
        // Set by the guest header on logout so a logged out user goes to
        // the normal /login route instead of back to the guest login form.
        if (shouldGoToLogin) {
            return {
                isSuccess: false,
                navigateTo: appRoutes.login(),
            };
        }
        return {
            isSuccess: false,
            navigateTo: `/guest/${guestLinkId}/login${fullHash}`,
            navigatedFrom,
        };
    }
    if (!currentUser.emailVerified) {
        return {
            isSuccess: false,
            navigateTo: '/verify-account-guest',
            navigatedFrom,
        };
    }
    return { isSuccess: true };
};
